// extracted by mini-css-extract-plugin
export default {"play":"Play-module--play--2d646","black":"Play-module--black--d6c3a","play__text":"Play-module--play__text--9baa6","play__svg":"Play-module--play__svg--258d6"};